import createLocationMiddleware from 'farce/createLocationMiddleware';

import {
  buildLocaleQuery,
  canonicalizeExplicitLocaleSearch,
  parseSearch,
} from './localeUrl';

const makeLocation = (location) => {
  const search = canonicalizeExplicitLocaleSearch(location.search);
  return search === location.search
    ? location
    : { ...location, query: parseSearch(search), search };
};

const buildLocationDescriptor = (location) => {
  const destinationQuery = location.query === undefined
    ? parseSearch(location.search)
    : location.query;
  const query = buildLocaleQuery({
    currentSearch: window.location.search,
    destinationQuery,
  });

  return {
    ...location,
    query,
  };
};

const localeHistoryMiddleware = createLocationMiddleware({
  makeLocation,
  makeLocationDescriptor: buildLocationDescriptor,
});

export default localeHistoryMiddleware;
